export class ScrollTo {
  constructor() {
    this.init();
  }

  init = () => {
    document.querySelectorAll('.anchor-link, .menu-anchor-link > a').forEach(link => {
      if(link){
        link.addEventListener('click', (e) => {
          const url = link.getAttribute("href");
          const anchor = new URL(url).hash;
          if(anchor && document.querySelector(anchor)){
            e.preventDefault();
            scrollToAnchor(anchor)
          }
        })
      }
    });
    function scrollToAnchor(id){
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
